module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-bet-selected@3x.png?1.0.17";